import {invert, pick, set, sortBy, uniq, values} from 'lodash';

export const frequencyPopulationMap = {
  AoU: {
    AFR: 'SSA',
    AMR: 'LAT',
    'All populations': 'ALL',
    EAS: 'EAS',
    EUR: 'EUR',
    MID: 'NEA',
    OTH: 'OTH',
    SAS: 'SAS',
  },
  CPIC: {
    'African American/Afro-Caribbean': 'AAC',
    'All populations': 'ALL',
    American: 'AME',
    'Central/South Asian': 'SAS',
    'East Asian': 'EAS',
    European: 'EUR',
    Latino: 'LAT',
    'Near Eastern': 'NEA',
    Oceanian: 'OCE',
    'Sub-Saharan African': 'SSA',
    Other: 'OTH',
  },
  PMBB: {
    AFR: 'SSA',
    AMR: 'AME',
    'All populations': 'ALL',
    EAS: 'EAS',
    EUR: 'EUR',
    SAS: 'SAS',
  },
  UKBB: {
    'African American/Afro-Caribbean': 'AAC',
    'All populations': 'ALL',
    'Central/South Asian': 'SAS',
    'East Asian': 'EAS',
    European: 'EUR',
    Other: 'OTH',
    'Sub-Saharan African': 'SSA',
  },
};

export const normalizePopulation = (source, value) => {
  if (!source || !value) return null;

  if (!frequencyPopulationMap[source]) {
    throw new Error(`${source} is not mapped`);
  }

  return frequencyPopulationMap[source][value] || value;
};

export const normalizeFrequency = (frequency) => {
  const population = normalizePopulation(frequency.dataSource, frequency.population);
  return set(frequency, 'population', population);
};

export const transformPerSource = (frequencies) => {
  const resultMap = {};

  for (let i = 0; i < frequencies.length; i += 1) {
    const frequency = frequencies[i];
    const {allele, alleleText, dataSource} = frequency;
    const currentResult = resultMap[alleleText] || {alleleText, allele};
    currentResult[dataSource] = pick(frequency, 'frequency', 'observedAlleles', 'totalAlleles', 'rare', 'population');
    resultMap[alleleText] = currentResult;
  }
  return values(resultMap);
};

export const displayName = (value) => {
  if (!value) return null;

  return invert(frequencyPopulationMap.CPIC)[value] || value;
};

export const uniquePopulations = (frequencies) => {
  return sortBy(uniq(frequencies.map((f) => f.population)));
};

/**
 * Compares two DataSource strings and sorts them alphabetically EXCEPT it always puts CPIC last
 *
 * @param {string} a - a DataSource string
 * @param {string} b - a DataSource string
 * @return {number} - comparison value
 */
export const compareFreqSources = (a, b) => {
  if (a === 'CPIC') return 1;
  if (b === 'CPIC') return -1;
  return a.localeCompare(b);
};
